import { Column, CreateDateColumn, Entity,UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";


@Entity('rm_indent_qty_limit')
export class RmIndentQtyLimit {

    @PrimaryGeneratedColumn("increment",{name:'rm_indent_qty_limit_id'})
    rmIndentQtyLimitId:number;

    @Column("datetime",{
        nullable:false,
        // length:30,
        name:"date"
    })
    date:any;

   @Column("int",{
    nullable:false,
    // length:10,
    name:"planned_qty"
    })
    plannedQty:number;

    @Column("int",{
    nullable:false,
    // length:10,
    name:"indent_qty"
    })
    indentQty:number;
   
   
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    updateAt: Date;

    @Column("varchar", {
        nullable: false,
        default:1,
        name: "created_user"
    })
    createdUser: string | null;
  
  
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar",{
        nullable : true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
    createdAt: Date;
}